const o = {
  id: "OhioClassicLotto",
  logo: !0,
  name: "Classic Lotto",
  style: {
    colorPrimary: "#005baa"
  }
};
export {
  o as default
};
